import React, { useState } from 'react';

const T  = '#4BC4B9'; /* teal — the only fill colour for the robot body */
const DV = '#111820'; /* dark — visor / eyes background                  */
const BG = '#1C2025'; /* site navbar background — wink lid colour        */

function RobotLogo({ className = '' }) {
  const [winking, setWinking] = useState(false);
  const onEnter = () => { if (!winking) setWinking(true); };

  return (
    <svg
      viewBox="0 0 100 108"
      className={`robot-logo-svg ${className}`}
      onMouseEnter={onEnter}
      role="img"
      aria-label="Coretez mascot"
      style={{ display: 'block', cursor: 'pointer', overflow: 'visible' }}
    >
      <defs>
        <style>{`
          .robot-logo-svg { height: 64px; width: auto; }
          @keyframes robotWink {
            0%   { transform: scaleY(0); }
            18%  { transform: scaleY(1); }
            72%  { transform: scaleY(1); }
            90%  { transform: scaleY(0); }
            100% { transform: scaleY(0); }
          }
          .r-lid {
            transform-box: fill-box;
            transform-origin: top center;
            transform: scaleY(0);
          }
          .r-lid.active {
            animation: robotWink 0.6s ease-in-out forwards;
          }
        `}</style>
        {/* Clip wink lid to visor bounds */}
        <clipPath id="visorClip">
          <rect x="22" y="27" width="56" height="32" rx="16"/>
        </clipPath>
      </defs>

      {/* ── Antenna stems — flat teal, no dark outline ── */}
      <line x1="37" y1="18" x2="25" y2="4"  stroke={T} strokeWidth="5" strokeLinecap="round"/>
      <line x1="63" y1="18" x2="75" y2="4"  stroke={T} strokeWidth="5" strokeLinecap="round"/>
      {/* Antenna balls */}
      <circle cx="25" cy="4"  r="4.8" fill={T}/>
      <circle cx="75" cy="4"  r="4.8" fill={T}/>

      {/* ── Arms — rounded shoulder blobs on upper sides of body, drawn before body ── */}
      <ellipse cx="14" cy="72" rx="13" ry="11" fill={T}/>
      <ellipse cx="86" cy="72" rx="13" ry="11" fill={T}/>

      {/* ── Body — moved down so it clears the visor bottom ── */}
      <rect x="16" y="63" width="68" height="38" rx="16" fill={T}/>

      {/* ── Head — flat teal ellipse, drawn on top of body so they merge seamlessly ── */}
      <ellipse cx="50" cy="43" rx="41" ry="27" fill={T}/>

      {/* ── Visor — dark pill ── */}
      <rect x="22" y="27" width="56" height="32" rx="16" fill={DV}/>

      {/* ── Eyes — teal ovals cut into the visor ── */}
      <ellipse cx="35" cy="43" rx="7" ry="9" fill={T}/>
      <ellipse cx="65" cy="43" rx="7" ry="9" fill={T}/>

      {/* ── Wink eyelid — slides down over right eye, clipped to visor ── */}
      <rect
        className={`r-lid${winking ? ' active' : ''}`}
        x="58" y="34"
        width="14" height="18"
        rx="7"
        fill={DV}
        clipPath="url(#visorClip)"
        onAnimationEnd={() => setWinking(false)}
      />
    </svg>
  );
}

export default RobotLogo;
